import { IconError } from './IconError'

export default IconError
export { IconError }
